import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=7864823d&scoped=true"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
import style0 from "./stock.vue?vue&type=style&index=0&id=7864823d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7864823d",
  null
  
)

export default component.exports